exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-recipes{display:flex;flex-direction:column;width:100%}.top-recipes__content{margin-top:20px}.top-recipes__footer{display:flex;justify-content:center;padding-top:5px}@media (max-width: 480px){.top-recipes__content{margin-top:0}.top-recipes__footer{border-top:none;padding-top:15px}}\n", ""]);

// exports
exports.locals = {
	"top-recipes": "top-recipes",
	"top-recipes__content": "top-recipes__content",
	"top-recipes__footer": "top-recipes__footer"
};